
/*
Copyright 2023 Breautek

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { Platform } from "./Platform";

/**
 * A strategy to resolve the runtime's platform
 */
export class PlatformResolver {
    public resolve(): Platform {
        if (this.isIOSEnvironment()) {
            return Platform.IOS;
        }
        else {
            // The only other supported platform is Android, so
            // it's assumed
            return Platform.ANDROID;
        }
    }

    public isIOSEnvironment(): boolean {
        return location.protocol === 'btfuse:';
    }

    public isAndroidEnvironment() {
        return !this.isIOSEnvironment();
    }
}
